module.exports = __webpack_public_path__ + "static/media/img165.7ed60768.jpg";